import Route from '@ember/routing/route';
import { service } from '@ember/service';
import FundsService from 'donor-elf-web/services/funds-service';

export default class MailchimpConnectedRoute extends Route {
  @service declare fundsService: FundsService;

  beforeModel() {
    return this.fundsService.confirmValidFundToken();
  }

  async model() {
    let mailchimpModel = this.modelFor('funds.fund.more.mailchimp');
    let { mailchimpSetting } = mailchimpModel;
    let funds = await this.fundsService.getAllFunds({
      filter: { has_ability_to_view_contact_name: true },
    });
    let changeset = {
      mailchimpSettingId: mailchimpSetting.id,
      fundId: this.fundsService.selectedFund!.id,
      mailchimpListId: mailchimpSetting.lists[0].id,
    };
    return {
      funds,
      changeset,
      ...mailchimpModel,
    };
  }

  resetController(controller: any, isExiting: boolean) {
    if (isExiting) {
      controller.reset();
    }
  }
}
